/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';

export class ConnectGcpOrganizationRequest {
  /**
  * Organization display name in Eon.
  */
  'name': string;
  'state': AccountState;
  /**
  * The organization ID.
  */
  'organizationId': string;
  /**
  * The GCP Organization folder ID.
  */
  'folderId'?: string;
  /**
  * GCP Organization management service account ID.
  */
  'managementServiceAccountId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "AccountState",
      "format": ""
    },
    {
      "name": "organizationId",
      "baseName": "organizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "folderId",
      "baseName": "folderId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementServiceAccountId",
      "baseName": "managementServiceAccountId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectGcpOrganizationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



